import Image, { ImageProps } from '@tb-core/components/ui/image';

import styles from './styles.scss';

const VisitorPrioritizationLogo = ({ ...props }: ImageProps) => (
    <Image className={styles.logo} {...props} />
);

export default VisitorPrioritizationLogo;
